import { useNavigationBarQuery } from "@crowdcoursing/api/graphql";
import { Business as BusinessIcon } from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/material";
import { useState } from "react";

import { useOrganizations } from "~hooks/useOrganizations";
import { Route } from "~services/router/Route";
import { PageHeader } from "~ui/atoms/PageHeader/PageHeader";

import { CreateOrganizationDialog } from "../../organisms/Organizations/CreateOrganizationDialog";
import { AdminOrganizationsTemplate } from "../../templates/AdminOrganizationsTemplate";

export const tCreate = "Create";
export const tAdminOrganizations = "Manage Organizations";

export const AdminOrganizationsPage = () => {
  const [isOrganizationDialogOpen, setIsOrganizationDialogOpen] = useState(false);
  const { data: navData } = useNavigationBarQuery();
  const isSiteAdmin = navData?.me.isSiteAdmin ?? false;

  const { organizations, isLoading, error } = useOrganizations();

  const handleOpenOrganizationDialog = () => setIsOrganizationDialogOpen(true);
  const handleCloseOrganizationDialog = () => setIsOrganizationDialogOpen(false);

  return (
    <Box sx={{ p: { sm: 2, xs: 1.5 } }}>
      <Stack spacing={2}>
        <PageHeader
          title={tAdminOrganizations}
          icon={<BusinessIcon data-variant="page-header" />}
          rightContent={
            isSiteAdmin ? (
              <Button onClick={handleOpenOrganizationDialog} variant="page-header">
                {tCreate}
              </Button>
            ) : undefined
          }
        />
        <AdminOrganizationsTemplate
          data={organizations}
          isSiteAdmin={isSiteAdmin}
          linkTo={(organization) => Route.organization({ organizationId: organization.id ?? "" })}
          showHeader={false}
          status={error ? "error" : isLoading ? "pending" : "success"}
        />
      </Stack>

      {isOrganizationDialogOpen && <CreateOrganizationDialog onClose={handleCloseOrganizationDialog} />}
    </Box>
  );
};
